import { ConversationServiceError } from '@staff/shared'

export const describeConversationError = (err: unknown): string => {
  if (err instanceof ConversationServiceError) {
    if (err.status === 401) return 'Din inloggning har gått ut. Logga in igen.'
    if (err.status === 403) {
      return 'Du saknar behörighet. Kontrollera att du är inloggad som rätt organisation, eller ladda om sidan.'
    }

    return err.apiMessage ? `${err.apiMessage} (status ${err.status})` : `Okänt fel (status ${err.status})`
  }

  if (err instanceof Error) return err.message

  return String(err)
}
